export default "__VITE_ASSET__IRLTIRwi__"